import { useEffect } from 'react';

/**
 * fn.uni_tools.simulateZoomApp (universal_fn_tools.js:1000) — the body-zoom
 * hack (parity 9 / risk R2): `document.body.style.zoom = min(1, innerWidth/1830,
 * innerHeight/950)`, forced to 1 when devicePixelRatio > 100%. Applied at boot
 * (MainView initialize) and on every resize (tunnel.js redrawCanvas re-calls
 * it). KEPT for fidelity — the toolbar width math (§8.1 updateStyles) and the
 * resolve-panel left math divide by this zoom; the verify harness pins the
 * viewport ≥1830×950 so zoom = 1 on both sides (R2).
 */
export function applyBodyZoom(): void {
  const widthRatio = Math.min(1, window.innerWidth / 1830);
  const heightRatio = Math.min(1, window.innerHeight / 950);
  const zoom =
    Math.round(window.devicePixelRatio * 100) > 100
      ? 1
      : Math.min(widthRatio, heightRatio);
  // Non-standard CSS property — exactly what the legacy board sets.
  (document.body.style as CSSStyleDeclaration & { zoom?: string | number }).zoom =
    String(zoom);
}

export function useBodyZoom(): void {
  useEffect(() => {
    applyBodyZoom();
    const onResize = () => applyBodyZoom();
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      (document.body.style as CSSStyleDeclaration & { zoom?: string | number }).zoom = '';
    };
  }, []);
}
